import { SyntheticEvent, useState } from 'react';

import { all, driver } from '../../const/commonConst';
import { SelectedOffsegMasterInfoType } from './useStateSelectedOffsegMasterInfo';

type InputType = {
	selectedOffsegMasterInfo: SelectedOffsegMasterInfoType;
	setSelectedOffsegMasterInfo: React.Dispatch<React.SetStateAction<SelectedOffsegMasterInfoType>>;
};

/**
 * Offsegの検索キー（車両 or ドライバー）の状態管理用カスタムフック
 */
export const useStateSearchKey = (input: InputType) => {
	const { selectedOffsegMasterInfo, setSelectedOffsegMasterInfo } = input;
	const [isCarSelectedAsKey, setIsCarSelectedAsKey] = useState(true); // Offsegの検索条件として車両が選択されたかどうかの管理

	// Offsegの検索キーを変更した際の処理
	const onChangeOffsegSearchKey = (event: SyntheticEvent<Element, Event>, value: string | null) => {
		if (value === driver.id) {
			setIsCarSelectedAsKey(false);
			setSelectedOffsegMasterInfo({ ...selectedOffsegMasterInfo, selectedOffsegCarInfo: all });
			return;
		}

		setIsCarSelectedAsKey(true);
		setSelectedOffsegMasterInfo({ ...selectedOffsegMasterInfo, selectedOffsegDriverInfo: all });
	};

	return {
		isCarSelectedAsKey,
		onChangeOffsegSearchKey,
	};
};
